<template>
    <fade-transition @after-enter="onShow" @after-leave="onLeave" :delay="0" :duration="{enter:300, leave: 0}"
                     mode="out-in" appear>
        <section v-show="show" class="sectionSingleVideo v-fade">
            <div ref="container" class="containerWrapper smoothReflow">
                <div class="container" :style="{height: smoothReflowHeight}">
                    <div class="content">
                        <div class="singleVideoContainer">
                            <div class="singleVideo__side singleVideo__side-video">
                                <div class="singleVideoWrapper" ref="videoWrapper">
                                    <video class="singleVideo"
                                           :poster="poster(ii_media)"
                                           ref="video"
                                           :controls="isPlaying"
                                           :autoplay="autoplay"
                                           :muted="muted"
                                           playsinline
                                           controlslist="nodownload"
                                           :src="source(ii_media)"

                                           @click="togglePlay()"
                                           @play="onPlay()"
                                           @pause="onPause()"
                                           @ended="onEnded()"
                                    >
                                        <source :src="source(ii_media)"
                                                type="video/mp4">
                                    </video>

                                    <div v-show="!isPlaying" class="singleVideo__playBtnWrapper">
                                        <button class="singleVideo__playBtn" type="button"
                                                @click.stop="togglePlay()">
                                            <img class="singleVideo__playBtnImg" src="/images/video-play-btn.svg"
                                                 alt="">
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="singleVideo__side singleVideo__side-videoInfo">
                                <div class="singleVideoInfo">
                                    <div class="singleVideoInfo__videoNameBrandWrapper">
                                        <h1 class="singleVideoInfo__client">
                                            {{ mediaProps().client }}
                                        </h1>

                                        <h2 class="singleVideoInfo__name">
                                            {{ mediaProps().title }}
                                        </h2>
                                    </div>

                                    <div class="singleVideoInfo__creditsWrapper">
                                        <ul class="singleVideoInfo__creditsListWrapper">
                                            <li v-if="credits('editor')" class="singleVideoInfo__creditsList">
                                                <div class="singleVideoInfo__creditsListTitle">
                                                    editor
                                                </div>
                                                <div class="singleVideoInfo__creditsListPerson">
                                                    {{ credits('editor') }}
                                                </div>
                                            </li>

                                            <li v-if="credits('agency')" class="singleVideoInfo__creditsList">
                                                <div class="singleVideoInfo__creditsListTitle">
                                                    agency
                                                </div>
                                                <div class="singleVideoInfo__creditsListPerson">
                                                    {{ credits('agency') }}
                                                </div>
                                            </li>

                                            <li v-if="credits('director')" class="singleVideoInfo__creditsList">
                                                <div class="singleVideoInfo__creditsListTitle">
                                                    director
                                                </div>
                                                <div class="singleVideoInfo__creditsListPerson">
                                                    {{ credits('director') }}
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div v-if="creditsMore().length" class="singleVideoInfo__additionalCreditsWrapper">
                                        <ul class="singleVideoInfo__creditsListWrapper singleVideoInfo__creditsListWrapper-additional"
                                            data-if="showMoreCredits"
                                            ref="moreCredits"
                                        >
                                            <li v-for="credit in creditsMore()" class="singleVideoInfo__creditsList">
                                                <div class="singleVideoInfo__creditsListTitle">
                                                    {{ credit.role }}
                                                </div>
                                                <div class="singleVideoInfo__creditsListPerson">
                                                    {{ credit.name }}
                                                </div>
                                            </li>

                                        </ul>

                                        <div class="singleVideoInfo__additionalCreditsBtnWrapper">
                                            <button class="singleVideoInfo__additionalCreditsBtn" type="button"
                                                    @click="toggleMoreCredits">
                                                <!--<img class="" src="img/credits_show_button.svg" alt="">-->
                                                <fade-transition :duration="{enter: 300, leave: 300}" mode="out-in">
                                                    <credits-hide-icon v-if="showMoreCredits"></credits-hide-icon>
                                                    <credits-show-icon v-else></credits-show-icon>
                                                </fade-transition>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <media-player-nav/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </fade-transition>

</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import {preloadImg, tryFullscreen, eventBus, wait, mediaProps, detectFirefox} from "../utils/shared";
import Hammer from 'hammerjs'
import smoothReflow from 'vue-smooth-reflow'

export default {
    props: ['media',],
    mixins: [smoothReflow],
    data() {
        return {
            show: false,
            video: null,
            isPlaying: false,
            muted: false,
            controls: false,
            ii_media: null,
            showMoreCredits: false,
            hammertime: null,
            smoothReflowHeight: null,
            //smoothReflowHeight: 'auto',
        }
    },
    computed: {
        ...mapGetters('ui', [
            'isMobile',
        ]),
        ...mapState({
            autoplay: state => state.player.autoplay,
        }),
    },
    created() {
    },
    mounted() {
        //console.log('player: mounted')
        this.onLeave()
        this.initHammer()
        this.initSmoothReflow()
        eventBus.$emit('route.changed')
    },
    destroyed() {
        if (this.hammertime) {
            this.hammertime.destroy()
        }

        eventBus.$emit('route.changed')
    },
    updated() {
    },
    watch: {
        '$route': 'onRoute',
        media() {
            this.isPlaying = false
        }
    },
    methods: {
        async onRoute() {
            this.show = false;
            this.$emit('hide')
        },
        async onLeave() {
            await this.initPoster()
            this.show = true
            //this.$emit('show')
            this.initVideo()
        },
        poster(media) {
            if (!media) return ''

            return media.thumbs.large.url
        },
        source(media) {
            if (!media) return ''

            return media.url
        },
        mediaProps() {
            if (!this.ii_media) return {}

            return mediaProps.get(this.ii_media)
        },
        credits(section) {
            if (!this.ii_media) return ''

            let credits = this.ii_media.credits

            return credits[section] && credits[section].name
                ? credits[section].name
                : ''
        },
        creditsMore() {
            return []
            // TODO decided to comment this functionality
            if (!this.ii_media) return []

            let credits = this.ii_media.credits

            return credits.more || []
        },
        initPoster() {
            let poster = this.poster(this.media)

            let container = this.$refs.container
            let adjustHeight = !!this.ii_media
            let containerHeight = window.getComputedStyle(container).height

            if (adjustHeight) {
                //container.style.height = containerHeight
                this.smoothReflowHeight = containerHeight
            }

            // added due to strange behavior on iOS 14:
            // when user plays video #1, pauses it, clicks on other video -> video-tag shows cached poster for video #1
            this.ii_media = null

            let promise = poster
                ? preloadImg(poster)
                    .catch(() => {
                        // fix for smoothReflow. without it container's height jumps due to 404 in poster
                        this.cleanPoster(this.media)
                    })
                : Promise.resolve()

            return promise
                .then(() => {
                    this.ii_media = this.media

                    if (this.$refs.container) {
                        //this.$refs.container.style.height = null
                        this.smoothReflowHeight = null
                        //this.smoothReflowHeight = 'auto';
                    }

                    //console.log('poster loaded')
                })
        },
        cleanPoster(media) {
            if (!media) {
                return
            }

            media.thumbs.large.url = null
        },
        initVideo() {
            this.controls = false

            if (this.autoplay) {
                this.$refs.video.play()
                this.$store.dispatch('player/setAutoplay', false)
            }
        },
        initHammer() {
            this.hammertime = new Hammer(this.$refs.videoWrapper)
            this.hammertime.on('swipeleft', () => {
                this.manualNext()
            })
            this.hammertime.on('swiperight', () => {
                this.manualPrev()
            })
        },
        initSmoothReflow() {
            // bug in smoothReflow
            // https://github.com/guanzo/vue-smooth-reflow/issues/22#issuecomment-1044734168
            if (detectFirefox()) {
                return;
            }

            this.$smoothReflow({
                el: '.smoothReflow',
                property: ['height',],
                transition: 'height .3s ease'
            });
        },
        onShow() {
            this.$emit('show')
        },
        onPlay() {
            if (this.isMobile) {
                tryFullscreen(this.$refs.video)
            }
            this.isPlaying = true
            this.controls = true
        },
        onPause() {
            //console.log('paused');
            //this.isPlaying = false
        },
        onEnded() {
            this.isPlaying = false
            this.controls = false
            this.$store.dispatch('player/setAutoplay', true)
            this.manualNext()
        },
        manualNext() {
            eventBus.$emit('player.next')
        },
        manualPrev() {
            eventBus.$emit('player.prev')
        },
        togglePlay() {
            if (!this.$refs.video) {
                return
            }

            if (this.controls) {
                return;
            }

            if (this.$refs.video.paused) {
                this.$refs.video.play()
            }
        },
        toggleMoreCredits() {
            let self = this
            let direction = this.showMoreCredits
                ? 'slideUp'
                : 'slideDown'

            $(this.$refs.moreCredits)[direction](400, function () {
                self.showMoreCredits = !self.showMoreCredits
            })
        },
    },

}
</script>

<style>
.singleVideo {
    display: block;
}
</style>
